/**
 * External Dependencies
 */
import $ from "jquery";
import "slick-carousel";
import Rellax from "rellax";
import AOS from "aos";
import "aos/dist/aos.css";

/**
 * Close megamenu's menu
 */
function closeMegamenu() {
  const menuItems = document.querySelectorAll(
    ".menu > .menu-item.menu-item-has-children"
  );
  menuItems.forEach((menuItem) => {
    if (menuItem.classList.contains("opened")) {
      menuItem.classList.remove("opened");
    }
  });
}

/**
 * Handles menu open/close in desktop
 */
function handleMegamenu() {
  const menuScrolled = document.getElementById("scrolled-menu");
  const menuMain = document.getElementById("main-menu");

  document.body.addEventListener("click", (event) => {
    if (
      !menuScrolled.contains(event.target) &&
      !menuMain.contains(event.target)
    ) {
      closeMegamenu();
    }
  });

  const menuItems = document.querySelectorAll(
    ".menu > .menu-item.menu-item-has-children"
  );

  menuItems.forEach((menuItem, key) => {
    menuItem.addEventListener("click", (event) => {
      if (event.target?.classList.contains("cursor-pointer")) {
        const needsToBeClosed = menuItem.classList.contains("opened");

        if (needsToBeClosed) {
          menuItem.classList.remove("opened");
        } else {
          menuItem.classList.add("opened");
          setTimeout(() => {
            menuItems.forEach((item, index) => {
              if (
                (index === key && needsToBeClosed) ||
                (index !== key && item.classList.contains("opened"))
              ) {
                item.classList.remove("opened");
              }
            });
          }, 300);
        }
      }
    });
  });
}

/**
 * Handle on scroll header and menu
 */
function handleHeader() {
  const headerContainer = document.getElementById("header-desktop");
  const headerLogo = document.getElementById('header-logo');

  if (window.screen.width > 1023) {
    window.onscroll = function () {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        if (!headerContainer.classList.contains("on-scrolling")) {
          headerContainer.classList.add("on-scrolling");
          closeMegamenu();
        }
        if (!headerLogo.classList.contains('on-scrolling')) {
          headerLogo.classList.add('on-scrolling');
        }
      } else if (
        document.body.scrollTop < 50 &&
        document.documentElement.scrollTop < 50 &&
        headerContainer.classList.contains("on-scrolling") &&
        headerLogo.classList.contains('on-scrolling')
      ) {
        headerContainer.classList.remove("on-scrolling");
        headerLogo.classList.remove('on-scrolling');
      }
    };
  }
}

/**
 * Handles slider for Fullpage modules
 */
function bindFullpageSlider() {
  const slickWrappers = document.querySelectorAll(".fullpage-slick");

  slickWrappers.forEach((wrapper) => {
    const slick = wrapper.querySelector(".slick");

    if (!slick) return;

    const prevArrow = wrapper.querySelector(".nav-prev");
    const nextArrow = wrapper.querySelector(".nav-next");

    $(slick).slick({
      slidesToShow: 1,
      swipe: true,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: true,
    });

    if (prevArrow) {
      prevArrow.addEventListener("click", () => {
        $(slick).slick("slickPrev");
      });
    }
    if (nextArrow) {
      nextArrow.addEventListener("click", () => {
        $(slick).slick("slickNext");
      });
    }
  });
}

/**
 * Handles slider for variants inside products
 */
function bindProductSlider() {
  const slickWrappers = document.querySelectorAll(".product-slick");

  slickWrappers.forEach((wrapper) => {
    const slick = wrapper.querySelector(".slick");

    if (!slick) return;

    const cards = $(wrapper).find('div.card');
    let colorsOrder = [];
    for(let i = 0; i < cards.length; i++) {
      colorsOrder.push($(cards[i]).attr('data-color'));
    }

    $(slick).slick({
      dots: true,
      fade: true,
      swipe: false,
      arrows: false,
      slidesToShow: 1,
      centerMode: true,
      customPaging: function (slider, i) {
        const colors = colorsOrder; //["gold", "white-gold", "pink-gold"];
        const color = (colors[i] === 'silver') ? 'white-gold' : colors[i];
        return (
          `<div class="relative h-4 w-4 rounded-full">` +
          `<div class="hidden absolute inset-0 border-2 border-${color} h-4 w-4 rounded-full fb-border"></div>` +
          `<div class="absolute bg-${color} h-2 w-2 rounded-full inset-0 m-auto text-center "></div>` +
          `</div>`
        );
      },
    });
  });
}

/**
 * Handles slider for products
 */
function bindSingleProductSlider() {
  if (window.innerWidth < 1024) {
    const slickWrappers = document.querySelectorAll(".single-product-slick");

    slickWrappers.forEach((wrapper) => {
      const slick = wrapper.querySelector(".slick");

      $(slick).not(".slick-initialized").slick({
        dots: true,
        fade: false,
        swipe: true,
        arrows: false,
        centerMode: true,
      });
    });
  }
}

/**
 * Handles generic sliders
 */
function bindSlider() {
  const slickWrappers = document.querySelectorAll(".slider-slick");

  slickWrappers.forEach((wrapper) => {
    const slick = wrapper.querySelector(".slick");
    const prevArrow = wrapper.querySelector(".nav-prev");
    const nextArrow = wrapper.querySelector(".nav-next");

    $(slick).slick({
      dots: false,
      swipe: true,
      arrows: false,
      centerMode: true,
      slidesToScroll: 1,
      variableWidth: true,
    });

    if (prevArrow) {
      prevArrow.addEventListener("click", () => {
        $(slick).slick("slickPrev");
      });
    }
    if (nextArrow) {
      nextArrow.addEventListener("click", () => {
        $(slick).slick("slickNext");
      });
    }
  });
}

/**
 * Handles slider for testimonial modules
 */
function bindTestimonialSlider() {
  const slickWrappers = document.querySelectorAll(".testimonial-slick");

  slickWrappers.forEach((wrapper) => {
    const slick = wrapper.querySelector(".slick");
    const prevArrow = wrapper.querySelector(".nav-prev");
    const nextArrow = wrapper.querySelector(".nav-next");

    const slides = slick.querySelectorAll(".testimonial-slide");

    $(slick).slick({
      dots: false,
      swipe: true,
      arrows: false,
      autoplay: true,
      infinite: false,
      centerMode: true,
      slidesToScroll: 1,
      variableWidth: true,
      autoplaySpeed: 2000,
      initialSlide: Math.floor((slides.length - 1) / 2) || 0,
    });

    if (prevArrow) {
      prevArrow.addEventListener("click", () => {
        $(slick).slick("slickPrev");
      });
    }
    if (nextArrow) {
      nextArrow.addEventListener("click", () => {
        $(slick).slick("slickNext");
      });
    }
  });
}

/**
 * Handles popup toggles
 */
function handlePopup() {
  const popupOpeners = document.querySelectorAll("*[data-popup]");

  popupOpeners.forEach((element) => {
    element.addEventListener("click", () => {
      const popupId = element.getAttribute("data-popup");
      const popupToOpen = document.getElementById(popupId);
      if (!popupToOpen) {
        return;
      }

      if (popupToOpen.classList.contains("open")) {
        popupToOpen.classList.remove("open");
      } else {
        popupToOpen.classList.add("open");
      }

      const closePopups = popupToOpen.querySelectorAll("[data-close_popup]");
      if (!closePopups?.length) {
        return;
      }
      closePopups.forEach((closePopup) => {
        closePopup.addEventListener("click", () => {
          if (popupToOpen.classList.contains("open")) {
            popupToOpen.classList.remove("open");
          }
        });
      });
    });
  });
}

/**
 * Handles megamenu search
 */
function handleSearch() {
  const searchItems = document.querySelectorAll("[data-search]");

  searchItems.forEach((searchItem) => {
    searchItem.addEventListener("click", () => {
      const searchEl = document.getElementById("search-container");

      if (!searchEl) {
        return;
      }

      if (searchEl.classList.contains("open")) {
        searchEl.classList.remove("open");
        searchItem.classList.remove("is_open");
      } else {
        searchEl.classList.add("open");
        searchItem.classList.add("is_open");
        const searchInput = document.querySelector("[data-search-input]");
        if (searchInput) {
          searchInput.focus();
        }

        closeMegamenu();
      }
    });
  });
}

/**
 * Handles all accordions
 */
function handleAccordion() {
  const accordionItems = document.querySelectorAll(".accordion");

  accordionItems.forEach((accordion) => {
    const accordionAlwaysOpen = accordion.classList.contains(
      "accordion-always-open"
    );

    const accordionItems = accordion.querySelectorAll(".accordion-item");

    if (accordionItems.length > 0 && accordionAlwaysOpen) {
      accordionItems[0].classList.add("open");
    }

    accordionItems.forEach((accordionItem) => {
      accordionItem.addEventListener("click", () => {
        if (accordionAlwaysOpen) {
          accordionItems.forEach((i) => {
            i.classList.remove("open");
          });
          accordionItem.classList.add("open");
          return;
        }

        accordionItems.forEach((i) => {
          if (i != accordionItem) i.classList.remove("open");
        });
        accordionItem.classList.toggle("open");
      });
    });
  });
}

/**
 * Handles menu toggled by the hamburger icon
 */
function handleHamburgerMenu() {
  const hamburger = document.querySelector(".hamburger");
  const mobileMenu = document.querySelector(".mobile-menu");
  hamburger.addEventListener("click", () => {
    hamburger.classList.toggle("open");
    mobileMenu.classList.toggle("hidden");
    document.body.classList.toggle("overflow-hidden");
    document.querySelector("header[data-header]").classList.toggle("h-screen");
  });
}

/**
 * Init Rellax animations
 */
function initRellax() {
  var rellax = new Rellax(".rellax", {
    center: true,
  });
}

/**
 * Init Aos animations (not in mobile to avoid overflow x)
 */
function initAOS() {
  AOS.init({
    once: true,
    disable: "mobile",
  });
}

$(() => {
  bindSlider();
  handlePopup();
  handleHeader();
  handleSearch();
  handleMegamenu();
  handleAccordion();
  bindProductSlider();
  bindFullpageSlider();
  handleHamburgerMenu();
  bindSingleProductSlider();
  bindTestimonialSlider();
  initRellax();
  initAOS();
  dreamStoryTitleStyle();

  megaMenuImages();
  megaMenuMobileImages();

  $(window).on("resize", function () {
    bindSingleProductSlider();
  });
});

function dreamStoryTitleStyle() {
  const titles = document.querySelectorAll(".dream-story-title");
  titles.forEach((title) => {
    title.innerHTML = title.innerHTML.replace(
      "&amp;",
      '<span class="text-secondary-dark">&amp;</span>'
    );
  });
}

function megaMenuImages() {
  // logic for mouse enter (hover in)
  $("a.menu-element").mouseenter(function () {
    const element = $(this).data("element");
    const closestSection = $(this).closest("section.submenu");
    const imagesWrapper = closestSection.find("div.menu-element-image-wrapper");
    imagesWrapper.find("div.menu-element-image").hide();
    if (
      imagesWrapper.find(
        'div.menu-element-image[data-element="' + element + '"]'
      ).length
    ) {
      imagesWrapper
        .find('div.menu-element-image[data-element="' + element + '"]')
        .show();
    } else {
      imagesWrapper
        .find('div.menu-element-image[data-element="default"]')
        .show();
    }
  });

  // logic for mouse leave (hover out)
  $("a.menu-element").mouseleave(function () {
    const closestSection = $(this).closest("section.submenu");
    const imagesWrapper = closestSection.find("div.menu-element-image-wrapper");
    imagesWrapper.find("div.menu-element-image").hide();
    // show only the default element
    imagesWrapper.find('div.menu-element-image[data-element="default"]').show();
  });
}

function megaMenuMobileImages() {
  // logic for mouse enter (hover in)
  $("a.mobile-menu-element").mouseenter(function () {
    const element = $(this).data("element");
    const closestSection = $(this).closest("section.submenu");
    const imagesWrapper = closestSection.find(
      "div.mobile-menu-element-image-wrapper"
    );
    imagesWrapper.find("div.mobile-menu-element-image").hide();
    if (
      imagesWrapper.find(
        'div.mobile-menu-element-image[data-element="' + element + '"]'
      ).length
    ) {
      imagesWrapper
        .find('div.mobile-menu-element-image[data-element="' + element + '"]')
        .show();
    } else {
      imagesWrapper
        .find('div.mobile-menu-element-image[data-element="default"]')
        .show();
    }
  });

  // logic for mouse leave (hover out)
  $("a.mobile-menu-element").mouseleave(function () {
    const closestSection = $(this).closest("section.submenu");
    const imagesWrapper = closestSection.find(
      "div.mobile-menu-element-image-wrapper"
    );
    imagesWrapper.find("div.mobile-menu-element-image").hide();
    // show only the default element
    imagesWrapper
      .find('div.mobile-menu-element-image[data-element="default"]')
      .show();
  });
}
